import { call, put, select } from 'redux-saga/effects';
import { Creators as actions } from '../actions';
import loadQuote from './api/loadQuote';
import changePaymentOptions from './changePaymentOptions'

/**
 * It will trigger the loadQuote saga
 *
 * @param {Object} payload - Data from action
 */
function* initializeStore({ queryParams }) {
    try {
        const { quoteId } = queryParams;
        const quoteSummary = yield call(loadQuote, quoteId);

        // if cash, get cashPurchaseOption
        // if lease or finance, get lease or finance
        // { [KEY_LIEN]: parseInt(value, 10) }
        yield call(changePaymentOptions, { })
    } catch (error) {
        console.log(error)
        yield put(actions.handleError(error));
    }
}

export default initializeStore;
